export enum CookieKey {
  TenantAuth = 'w_k_t',
  UserAuth = 'w_k_u',
}

export enum StorageKey {
  PrevParentCode = 'prev_p',
  PrevChildCode = 'prev_c',
}
